export default function formatDate(dateInput) {
//     console.log(dateInput)
//   if (!dateInput) return "";
//   const date = new Date(dateInput);
//   const day = date.getDate().toString().padStart(2, "0");
//   const month = date.toLocaleString("en-US", { month: "long" });
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
  if (!dateInput) return "";

  const date = new Date(dateInput);
  if (isNaN(date)) return "";

  const day = date.getDate().toString().padStart(2, "0");
  const monthAlias = date.toLocaleString("en-US", { month: "short" }); // e.g., Oct
  const yearShort = date.getFullYear().toString().slice(0); // e.g., 25

  return `${day} ${monthAlias} ${yearShort}`;

}